import { render, staticRenderFns } from "./digitalScreen.vue?vue&type=template&id=31c03ad6&scoped=true&"
import script from "./digitalScreen.vue?vue&type=script&lang=js&"
export * from "./digitalScreen.vue?vue&type=script&lang=js&"
import style0 from "./digitalScreen.vue?vue&type=style&index=0&id=31c03ad6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c03ad6",
  null
  
)

export default component.exports